define('core/loader',['require','ns'],function (require) {
	'use strict';

	var ns = require('ns');

	var Loader = function () {
	};

	Loader.prototype = {

		loadCss: function (callback) {

			var $container = $('head');
			var $files = $container.find('[rel=stylesheet]');

			var _urls = [];
			var _callback = callback || function () { };

			var _appendFiles = function () {

				var fragment = document.createDocumentFragment();

				$files.each(function () {

					var link = document.createElement('link');

					link.href = $(this).data('href');
					link.rel = 'stylesheet';
					link.type = 'text/css';

					fragment.appendChild(link);
				});

				$files.remove();

				$container[0].appendChild(fragment);
			};

			var _getFile = function (fileUrl) {
				
				return $.get(fileUrl);
			};

			$files.each(function () {

				_urls.push($(this).data('href'));
			});

			$.when
				.apply($, $.map(_urls, _getFile))
				.then(function () {

					_appendFiles();
					
					setTimeout(function () {
						
						_callback();
						
					}, 100);
				});
		},
		
		loadImg: function ($target, url, callback) {
			
			var _callback = callback || function () { };
			var _url = url || '';
			
			if (_.isEmpty(_url)) {
			
				$target.attr('src', ns.config.get('imagePlaceholder'));
				
				return _callback();
			}
			
			var imgObj = new Image();
			
			imgObj.src = _url;
			
			imgObj.onload = function () {
				
				ns.logger.debug('Loader', 'loadImg: loaded ' + this.src);
				
				$target.attr('src', this.src);
				
				_callback();
			};
			
			imgObj.onerror = function () {
			
				ns.logger.error('Loader', 'loadImg: fail to load' + this.src);
				
				$target.attr('src', ns.config.get('imagePlaceholder'));
				
				_callback();
			};
		},
		
		loadImgBySrcset: function ($target, callback) {
			
			var _callback = callback || function () { };
			
			var targetWidth = $target.width();
			var srcMap = this._getImgSrcset($target);
						
			var optimalImg = _.find(srcMap, function (src) {
				
				return src.width >= targetWidth;
			});
			
			if (_.isUndefined(optimalImg)) {
				
				srcMap.reverse();
				
				optimalImg = srcMap[0] || {};
			}
			
			var currentImgUrl = $target.attr('src');
			
			if (_.isUndefined(currentImgUrl) || currentImgUrl !== optimalImg.url) {
				
				this.loadImg($target, optimalImg.url, callback);
			}
		},
		
		_getImgSrcset: function ($target) {
			
			var _srcset = $target.data('srcset') || '';
			var _srcList = _.isEmpty(_srcset) ? [] : _srcset.split(', ');
			
			var srcMap = [];
			
			for (var i = 0, length = _srcList.length; i < length; i++) {
				
				var temp = _srcList[i].match(/([^ ]*) ([0-9]*)/i);
				
				if (temp.length === 3) {
					
					srcMap.push({
						width: temp[2],
						url: temp[1]
					});
				}
			}
			
			return srcMap;
		}
	};

	return Loader;
});
